import { ROUTE_NAMES } from './routeNames.const'

export const routeDashboard = {
  path: '/synthese',
  name: ROUTE_NAMES.synthesis,
  component: () =>
    import(
      /* webpackChunkName: "Dashboard" */ 'src/pages/Dashboard/Dashboard.vue'
    ),
}
